import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';
import { color } from '@mui/system';
import { useEffect, useState} from 'react';
import { useConfig } from '../../Services/useConfig';


const DrawerHeader = styled('div')(({ theme }) => ({
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));


export default function LeftMainDrawerMobile(props: any) {
    
    const config = useConfig()

    return (
        <Drawer
            //todo: move to own component
            transitionDuration={0}
            sx={{
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: config.general["leftDrawerWidthMobile"],
                    boxSizing: "border-box",
                },
            }}
            BackdropProps = {{
                invisible:true,
            }}
            onClose={() => props.setLeftMainDrawerOpen(false)}
            // variant="permanent"
            anchor="left"
            open={props.leftMainDrawerOpen}
            
        >
            <DrawerHeader>
                <AppBar
                    sx={{
                        width: config.general["leftDrawerWidthMobile"],//`${props.drawerWidth}px`,
                        ml: 0,
                        mr: `calc(100% - ${config.general["leftDrawerWidthMobile"]})`
                    }}>
                    <Toolbar>
                        <Box display='flex' flexGrow={1}>
                            <Typography variant="h6" component="div">
                                Waldmonitor
                            </Typography>
                        </Box>
                        <IconButton edge="end" color="inherit" aria-label="open drawer" onClick={() => props.setLeftMainDrawerOpen(!props.leftMainDrawerOpen)} >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
            </DrawerHeader>
            {props.children}
        </Drawer>

    );
}